document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const infoBlocks = document.querySelectorAll('.ambassadors__info_block');
  
  if (infoBlocks.length) {
    infoBlocks.forEach((block) => {
      const title = block.querySelector('.ambassadors__info_block--title');
      const subtitle = block.querySelector('.ambassadors__info_block--subtitle');
      const text = block.querySelector('.ambassadors__info_block--text');
      const img = block.querySelector('.info_block-img');
      const coloredBox = block.querySelector('.ambassadors__info_colored--block');
      const coloredLinkSpan = coloredBox?.querySelector('.ambassadors__info_colored--block-link span');
  
      // Title fade from top
      if (title) {
        gsap.fromTo(title,
          { y: -20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: title,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Subtitle fade with delay
      if (subtitle) {
        gsap.fromTo(subtitle,
          { y: -10, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            delay: 0.1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: subtitle,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Text fade in
      if (text) {
        gsap.fromTo(text,
          { y: 10, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            delay: 0.15,
            ease: "power2.out",
            scrollTrigger: {
              trigger: text,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Image slide-in and fade (alternate left/right by index)
      if (img) {
        const isOdd = block.classList.contains('block-1') || block.classList.contains('block-3') || block.classList.contains('block-5');
        const fromX = isOdd ? 30 : -30;
      
        gsap.fromTo(img,
          { x: fromX, scale: 1.05, opacity: 0 },
          {
            x: 0,
            scale: 1,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: img,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Colored Box slide up
      if (coloredBox) {
        gsap.fromTo(coloredBox,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
            scrollTrigger: {
              trigger: coloredBox,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Link span scale in
      if (coloredLinkSpan) {
        gsap.fromTo(coloredLinkSpan,
          { scale: 0.95, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            delay: 0.4,
            duration: 0.3,
            ease: "power2.out",
            scrollTrigger: {
              trigger: coloredLinkSpan,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
    });
  }

  ScrollTrigger.refresh();
});
